import React from 'react';
import { installVerificationApi } from '../services/api';
import { InstallPhaseWorkspace, InstallPhaseConfig } from './InstallPrepTask';

const INSTALL_VERIFICATION_CONFIG: InstallPhaseConfig = {
  phase: 'VERIFICATION',
  api: installVerificationApi,
  copy: {
    caseLabel: 'Install Verification',
    totalTimeLabel: 'Total verification time (hours)',
    headerStatus: {
      IN_PROGRESS: 'In verification',
      ON_HOLD: 'On hold',
      COMPLETED: 'Ready for handoff'
    },
    statusButtonLabels: {
      IN_PROGRESS: 'In verification',
      ON_HOLD: 'On hold',
      COMPLETED: 'Ready'
    },
    summaryPlaceholder: 'Generate a summary of verification and handoff findings for the customer.',
    summaryGenerateLabel: 'Generate summary',
    summaryGeneratingLabel: 'Generating…',
    summaryEditLabel: 'Edit summary',
    summaryNoDataLabel: 'No verification summary yet.',
    runNotesLabel: 'Verification notes',
    markCompleteButtonLabel: 'Mark ready for handoff',
    loadingMessage: 'Loading verification checklist...',
    loadError: 'Failed to load verification task',
    saveError: 'Failed to save verification task'
  },
  preInstallCheck: {
    title: 'Installation handoff',
    description: 'Install execution status summary before verification begins.',
    statusKey: 'installExecutionStatus',
    badgeLabels: {
      COMPLETE: 'Install complete',
      NOT_REQUIRED: 'Not required',
      INCOMPLETE: 'Install incomplete',
      INCOMPLETE_WITH_REASON: 'Incomplete with note',
      PARTIAL: 'Install partial',
      UNKNOWN: 'Pending'
    },
    outstandingTitle: 'Outstanding install items',
    noteLabel: 'Technician note',
    actionLabel: 'Open install workspace',
    actionPath: 'exec',
    completeActionLabel: 'Open install workspace',
    openActionLabel: 'Open install workspace',
    readyDescription: 'Installation is complete and ready for verification.',
    notRequiredDescription: 'Installation handoff is marked not required for this verification.',
    requirementOverrideMetadataKey: 'installExecutionRequirementOverride',
    notRequiredConfirmTitle: 'Installation handoff not required',
    notRequiredConfirmMessage:
      'Mark the installation handoff as not required for this verification? This does not complete the install task; it records that verification can continue without it.',
    notRequiredNote: 'Installation handoff marked not required for this verification.',
    requireActionLabel: 'Require install handoff'
  },
  enforceLayout: 'site',
  disableStepNotes: true
};

const InstallVerificationTask: React.FC = () => {
  return <InstallPhaseWorkspace config={INSTALL_VERIFICATION_CONFIG} />;
};

export default InstallVerificationTask;
